import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button, Table } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const SubCategoryGallery = () => {
    const [imageFiles, setImageFiles] = useState([]);
    const [imgs, setImgs] = useState([]);
    const { id } = useParams();
    const [formData, setFormData] = useState({
        sub_category_id: id,
        type: 1,
        caption: "",
        status: 1,
        images: "",
    });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const {
        AuthReducer: { auth },
    } = useSelector((state) => state);
    const navigate = useNavigate();

    const inputHandler = (e) => {
        const { name, value, type, files, checked } = e.target;
        if (name === "images" && files) {
            setFormData({ ...formData, [name]: files });
        } else if (type === "checkbox" && name === "status") {
            setFormData({ ...formData, [name]: checked ? 1 : 0 });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        setImageFiles(files);
    };

    const handleSubmit = async () => {
        const form = new FormData();
        imageFiles.forEach((file) => {
            form.append("images", file);
        });
        Object.entries(formData).forEach(([key, value]) => {
            if (key !== "images") form.append(key, value);
        });
        try {
            const res = await axios.post(`/api/admin/v1/add-subcategory-gallery`, form, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            });
            toast.success(res.data?.message);
            navigate(-1);
        } catch (err) {
            toast.error(err.response?.data?.message || "Something went wrong");
            setErrors(err.response?.data?.errors || {});
            setMessage(err.response?.data?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        axios(`/api/admin/v1/edit-gallery-subcategory/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            console.log(res.data?.data?.sub_category_gallery_images);
            setImgs(res.data?.data?.sub_category_gallery_images || []);
        })
            .catch((err) => console.log(err));
    }, [auth, id]);

    const handleDelImage = (imgId) => {
        if (window.confirm("Are You Sure You Want To Delete This Gallery image.")) {
            axios
                .delete(`/api/admin/v1/subcategory-gallery-image-delete/${imgId}`, {
                    headers: {
                        Authorization: `Bearer ${auth?.token}`,
                    },
                })
                .then((res) => {
                    toast.success(res.data.message);
                    setImgs((prev) => prev.filter((img) => img.id !== imgId));
                })
                .catch((err) => toast.error("Something Went Wrong"));
        }
    };

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-white">Add SubCategory Gallery</h4>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2 my-4">
                <div className="row">
                    {message && <h3 className="d-block text-danger text-center">{message}</h3>}
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Caption</Label>
                            <Input
                                value={formData.caption}
                                name="caption"
                                onChange={inputHandler}
                            />
                            <span className="d-block text-danger">{errors?.caption}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Upload Images</Label>
                            <Input
                                type="file"
                                name="images"
                                invalid={Boolean(errors?.images)}
                                multiple
                                onChange={handleImageChange}
                            />
                            <span className="d-block text-danger">{errors?.images}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup switch>
                            <Input
                                type="switch"
                                checked={formData.status === 1}
                                onChange={inputHandler}
                                name="status"
                            />
                            <Label check>Status</Label>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-4">
                        <Button color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                        <Button className="ms-3" onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                    </div>
                </div>
                <Table hover responsive className="mt-2">
                    <thead>
                        <tr>
                            <th>SL. No.</th>
                            <th>Image</th>
                            <th>Caption</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {imgs.length === 0 ? (
                            <tr>
                                <td colSpan="4">No images found</td>
                            </tr>
                        ) : (
                            imgs.map((img, idx) => (
                                <tr key={img.id}>
                                    <td>{idx + 1}</td>
                                    <td>
                                        <img
                                            src={`https://india-tourism.s3.ap-south-1.amazonaws.com/${img?.gallery_image}`}
                                            height={45}
                                            width={45}
                                        />
                                    </td>
                                    <td>{img.caption}</td>
                                    <td>
                                        <AiOutlineDelete
                                            size={22}
                                            className="text-danger"
                                            onClick={() => handleDelImage(img.id)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default SubCategoryGallery; 